export const MONTHLY = 'monthly';
export const ANNUAL = 'annual';
export const ONCE = 'once';